import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    nivelSocioEconomico: [],
  },

  getters: {
    getNivelSocioeconomico: (state) => state.nivelSocioEconomico,
  },

  mutations: {
    SET_NIVEL_SOCIOECONOMICO(state, nivelSocioEconomico) {
      state.nivelSocioEconomico = nivelSocioEconomico;
    },
  },

  actions: {
    async fetchNivelSocioeconomico({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catnivelSocioeconomico')
        .then((response) => {
          commit('SET_NIVEL_SOCIOECONOMICO', response.data.data);
        });
    },
  },
};
